import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'image-detail',
  templateUrl: './image-detail.component.html',
  styleUrls: ['./image-detail.component.scss'],
})
export class ImageDetailComponent {
  @Input() image: string;
  @Input() closeModal: () => void;

  close() {
    this.closeModal();
  }
}
